import React, { useState, useEffect } from "react";

const seasons = {
    summer: {
        name: "Sommer",
        months: [5, 6, 7, 8, 9], // May to September
        openingHours: {
            Montag: ["Ruhetag"],
            "Dienstag bis Freitag": [
                "11:30 Uhr - 14:00 Uhr",
                "14:00 Uhr - 23:00 Uhr",
                "Warme Küche bis 21:30 Uhr",
            ],
            "Samstag und Sonntag": [
                "11:30 Uhr - 23:00",
                "Warme Küche bis 21:30 Uhr",
            ],
            Feiertage: ["11:30 Uhr - 23:00 Uhr", "Warme Küche bis 21:30 Uhr"],
        },
    },
    winter: {
        name: "Winter",
        months: [10, 11, 12, 1, 2, 3, 4], // October to April
        openingHours: {
            "Montag und Dienstag": ["Ruhetag"],
            "Mittwoch bis Freitag": [
                "11:30 Uhr - 14:00 Uhr",
                "17:00 Uhr - 23:00 Uhr",
                "Warme Küche bis 21:30 Uhr",
            ],
            Samstag: ["17:00 Uhr - 23:00 Uhr", "Warme Küche bis 21:30 Uhr"],
            Sonntag: ["11:30 Uhr - 23:00 Uhr", "Warme Küche bis 20:30 Uhr"],
            Feiertage: ["11:30 Uhr - 23:00 Uhr", "Warme Küche bis 20:30 Uhr"],
        },
    },
};

const OpeningHours = () => {
    const [selectedSeason, setSelectedSeason] = useState("summer");

    useEffect(() => {
        const currentMonth = new Date().getMonth() + 1; // JavaScript months are 0-indexed
        const isSummer = seasons.summer.months.includes(currentMonth);
        setSelectedSeason(isSummer ? "summer" : "winter");
    }, []);

    const handleSeasonChange = (season) => {
        setSelectedSeason(season);
    };

    const openingHours = seasons[selectedSeason].openingHours;

    return (
        <div className="mx-auto p-6 container my-32 ">
            <div className="bg-white shadow-md rounded-lg p-6 w-full">
                <h2 className="text-2xl font-semibold text-gray-800">
                    Öffnungszeiten
                </h2>
                <h4 className="text-lg font-semibold text-gray-800 my-4">
                    Sonn- und Feiertag durchgehend geöffnet.
                </h4>
                <div className="flex justify-start my-4">
                    <button
                        onClick={() => handleSeasonChange("summer")}
                        className={`px-4 py-2 rounded-md text-sm font-medium ${
                            selectedSeason === "summer"
                                ? "bg-enedemgreen text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                    >
                        {seasons.summer.name}
                    </button>
                    <button
                        onClick={() => handleSeasonChange("winter")}
                        className={`ml-4 px-4 py-2 rounded-md text-sm font-medium ${
                            selectedSeason === "winter"
                                ? "bg-enedemgreen text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                    >
                        {seasons.winter.name}
                    </button>
                </div>
                {selectedSeason === "summer" ? (
                    <p className="text-gray-600 mb-4">
                        Unsere Sommeröffnungszeiten (Mai bis September):
                    </p>
                ) : (
                    <p className="text-gray-600 mb-4">
                        Unsere Winteröffnungszeiten (Oktober bis April):
                    </p>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {Object.entries(openingHours).map(([day, hours]) => (
                        <div
                            key={day}
                            className="flex flex-col bg-gray-100 rounded-md p-4"
                        >
                            <span className="font-medium text-gray-700 mb-2">
                                {day}
                            </span>
                            <ul className="text-gray-600 space-y-1">
                                {hours.map((time, index) => (
                                    <li key={index} className="text-sm">
                                        {time}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OpeningHours;
